import React, { useState } from "react";

/** An app's logo, or its first letter when the catalog has none. */
export const AppLogo = ({ app }) => {
  const [isBroken, setIsBroken] = useState(false);

  return app.logo && !isBroken ? (
    <img className="aav2-apps-logo" src={app.logo} alt="" onError={() => setIsBroken(true)} />
  ) : (
    <span className="aav2-apps-logo">{(app.name || app.app).charAt(0).toUpperCase()}</span>
  );
};

/** One row of an Apps & MCP list: the logo (or `icon`), the name (and a line under it), the actions on the right, and what opens under the row. */
export const AppRow = ({ app, icon, detail, actions, below }) => (
  <li className="aav2-apps-entry">
    <div className="aav2-apps-row">
      {icon || <AppLogo app={app} />}
      <span className="aav2-apps-row-text">
        <b>{app.name}</b>
        {detail && <small>{detail}</small>}
      </span>
      {actions && <span className="aav2-apps-row-actions">{actions}</span>}
    </div>
    {below}
  </li>
);
